import * as React from 'react';

/**
 * Utility hook to access a ref to a component instance in a list.
 */
export function useMapRefs<Item extends object, Element>(): (
    item: Item
) => React.RefObject<Element> {
    const refs = React.useRef(new WeakMap());

    return React.useCallback((item: Item) => {
        if (!refs.current.has(item)) {
            refs.current.set(item, React.createRef());
        }

        return refs.current.get(item);
    }, []);
}
